import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    Autocomplete,CircularProgress
} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {fetchClasses} from '../master/classsection/redux/Action';
import {fetchStudents} from '../student/redux/studentActions';
import { api ,selectSchoolDetails} from '../../../common';
import MasterJson from "../../masterfile/MasterJson.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const ComplainForm = () => {
    const dispatch = useDispatch();

    // Fetch data from Redux
      const userData = useSelector(selectSchoolDetails);
      console.log("userdatad",userData)
        const schoolId = userData?.id;
    const [complainantType, setComplainantType] = useState('');
     const classSections=useSelector((state)=>state.master.data.classSections)
const [students, setStudents] = useState([]);
const [loadingStudents, setLoadingStudents] = useState(true);
const [studentError, setStudentError] = useState(null);

    // Form data structure
const [formData, setFormData] = useState({
  studentName: '',       // For student complaints
  staffName: '',         // For staff complaints
  className: '',         // Class name (e.g., "10th Grade")
  section: '',           // Section (e.g., "A")
  complaintType: '',     // Complaint category (maps to "type")
  title: '',             // Short title/description (maps to "title")
  description: '',       
  status: 'OPEN',        
});
const [snackbar, setSnackbar] = useState({
  open: false,
  message: '',
  severity: 'success', // or 'error'
});
 const [showCustomComplaint, setShowCustomComplaint] = useState(false);
    // Complaint categories for Staff and Students
    const staffComplaintCategories = [
        'Workplace Issue',
        'Harassment',
        'Salary Issue',
        'Leave Policy Concern',
        'Infrastructure Concern',
        'Conflict with Colleagues',
        'Equipment Issue',
        'Health and Safety',
        'Discrimination',
        'Other',
    ];

    const studentComplaintCategories = [
        'Bullying',
        'Teacher Misconduct',
        'Academic Concern',
        'Transport Issue',
        'Hostel Concern',
        'Library Issue',
        'Sports Facilities',
        'Examination Concern',
        'Fees Issue',
        'Other',
    ];

    useEffect(() => {
        if (schoolId) {
            dispatch(fetchClasses(schoolId));
        }
    }, [schoolId, dispatch]);

    useEffect(() => {
        if (complainantType === 'Student') {
            dispatch(fetchStudents());
        }
    }, [complainantType, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'complainantType') {
      setComplainantType(value);
    } 
    else if (name === 'complaintType') {
      // Check if "Other" was selected
      const isOtherSelected = value === 'Other';
      
      setShowCustomComplaint(isOtherSelected);
      setFormData(prev => ({
        ...prev,
        complaintType: isOtherSelected ? '' : value
      }));
    }
    else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };


    const handleTypeChange = (event) => {
        setComplainantType(event.target.value);
        setFormData({
            name: '',
            section: '',
            class: '',
            rollNo: '',
            post: '',
            designation: '',
            complaintType: '',
            description: '',
        });
    };
const handleSubmit = async () => {
    try {
        if (!userData?.id) {
            throw new Error('Missing required user information. Please login again.');
        }

  const payload = {
      studentId: userData.role === 'student' ? userData.id : 0,
      staffId: userData.role === 'staff' ? userData.id : 0,
      className: formData.className || '',
      section: formData.section || '',
      schoolId: userData.schoolId,  // School ID from user data
      session: userData.session,
      studentName:  formData.studentName ,
      staffName:  formData.staffName ,
      type: formData.complaintType,  // Complaint category
      title: formData.title,         // Short title
      status: formData.status.toUpperCase(),  // Ensure uppercase
      creationDateTime: new Date().toISOString(),
      messages: [
        {
          senderName: userData.name,  // Logged-in user's name
          message: formData.description,
          sentAt: new Date().toISOString()
        }
      ]
    };


        // API call to create ticket
        const response = await api.post('/api/complains', payload);
        
        // if (!response.ok) {
        //     const errorData = await response.json();
        //     throw new Error(errorData.message || 'Ticket creation failed');
        // }

        // Reset form to initial state
        setFormData({
            name: '',
            section: '',
            class: '',
            rollNo: '',
            post: '',
            designation: '',
            complaintType: '',
            description: '',
            status:''
        });
        
        // Show success message
      setSnackbar({
      open: true,
      message: "Complaint submitted successfully!",
      severity: "success",
    });

  } catch (error) {
    setSnackbar({
      open: true,
      message: error.message || "Submission failed",
      severity: "error",
    });
    }
};

  useEffect(() => {
        const fetchStudent = async () => {
            try {
                const response = await api.get("/api/students");
                setStudents(response.data);
            } catch (err) {
                setStudentError(err.message);
            } finally {
                setLoadingStudents(false);
            }
        };
        fetchStudent();
    }, []);
    return (
      <Paper elevation={3} style={{padding: '20px'}}>
    <Typography variant="h6" gutterBottom>
        Submit a Complaint
    </Typography>

    <FormControl fullWidth style={{marginBottom: '20px'}}>
        <InputLabel>Select Complainant Type</InputLabel>
        <Select label="Select Complainant Type" value={complainantType} onChange={handleTypeChange}>
            <MenuItem value="Student">Student</MenuItem>
            <MenuItem value="Staff">Staff</MenuItem>
        </Select>
    </FormControl>

    {complainantType && (
        <Box>
           {complainantType && (
        <>
          <FormControl fullWidth style={{ marginBottom: '20px' }}>
            <InputLabel>Select Complaint Type</InputLabel>
            <Select
              label="Select Complaint Type"
              name="complaintType"
              value={showCustomComplaint ? 'Other' : formData.complaintType}
              onChange={handleChange}
            >
              {(complainantType === 'Staff'
                ? staffComplaintCategories
                : studentComplaintCategories
              ).map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Custom Complaint Field - Shows when "Other" is selected */}
          {showCustomComplaint && (
            <TextField
              fullWidth
              label="Please specify your complaint"
              name="customComplaint"
              value={formData.complaintType}
              onChange={(e) => setFormData(prev => ({
                ...prev,
                complaintType: e.target.value
              }))}
              style={{ marginBottom: '20px' }}
            />
          )}
        </>
      )}

        
        
      

            {/* Added Title Field */}
            <TextField
                fullWidth
                label="Title*"
                name="title"
                value={formData.title}
                onChange={handleChange}
                style={{marginBottom: '20px'}}
                required
            />

            {/* Status Moved Here (Common for both) */}
            <FormControl fullWidth style={{marginBottom: '20px'}}>
                <InputLabel>Status</InputLabel>
                <Select
                    label="Status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                >
                    <MenuItem value="OPEN">Open</MenuItem>
                    <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
                    <MenuItem value="RESOLVED">Resolved</MenuItem>
                    <MenuItem value="CLOSED">Closed</MenuItem>
                </Select>
            </FormControl>

            {complainantType === 'Student' && (
                <>
    <FormControl fullWidth style={{ marginBottom: '20px' }}>
  <Autocomplete
    options={students}
    value={students.find(s => s.id === formData.studentId) || null}
    onChange={(event, newValue) => {
      if (newValue) {
        setFormData(prev => ({
          ...prev,
          studentId: newValue.id,
          studentName: newValue.studentName
        }));
      }
    }}
    getOptionLabel={(option) => 
      `${option.studentName} (Admission no-${option.admissionNo})`
    }
    filterOptions={(options, state) => {
      const inputValue = state.inputValue.toLowerCase();
      return options.filter(option => 
        option.studentName.toLowerCase().includes(inputValue) ||
        (option.rollNo && option.rollNo.toString().toLowerCase().includes(inputValue)) ||
        (option.admissionNo && option.admissionNo.toString().toLowerCase().includes(inputValue))
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Select Student"
        error={!!studentError}
        helperText={studentError}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loadingStudents && <CircularProgress color="inherit" size={20} />}
              {params.InputProps.endAdornment}
            </>
          )
        }}
      />
    )}
    renderOption={(props, option) => (
      <li {...props}>
        {option.studentName} (Admission no-{option.admissionNo})
        {option.rollNo && ` - Roll no: ${option.rollNo}`}
      </li>
    )}
    loading={loadingStudents}
    disabled={loadingStudents || studentError}
    noOptionsText={
      loadingStudents ? "Loading..." : 
      studentError ? `Error: ${studentError}` : 
      "No matching students found"
    }
  />
</FormControl>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <InputLabel>Select Class</InputLabel>
                                <Select
                                    label="class"
                                    name="className"
                                    value={formData.className}
                                    onChange={handleChange}
                                >
                                    {classSections && classSections.length > 0 ? (
                                        classSections.map((cls) => (
                                            <MenuItem key={cls.id} value={cls.name}>
                                                {cls.name}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem disabled>No classes available</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel>Select Section</InputLabel>
                                <Select
                                    label="section"
                                    name="section"
                                    value={formData.section}
                                    onChange={handleChange}
                                    disabled={!formData.className}
                                >
                                    {formData.className ? (
                                        classSections
                                            .find((cls) => cls.name === formData.className)
                                            ?.sections?.map((sec) => (
                                                <MenuItem key={sec.id} value={sec.name}>
                                                    {sec.name}
                                                </MenuItem>
                                            )) || <MenuItem disabled>No sections available</MenuItem>
                                    ) : (
                                        <MenuItem disabled>Please select a class first</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </>
            )}

            {complainantType === 'Staff' && (
                <FormControl fullWidth style={{marginBottom: '20px'}}>
                    <TextField
                        fullWidth
                        label="Staff Name"
                        name="staffName"
                        value={formData.staffName}
                        onChange={handleChange}
                    />
                </FormControl>
            )}

            <TextField
                fullWidth
                label="Complaint Description*"
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                rows={4}
                style={{marginBottom: '20px'}}
                required
            />

            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                fullWidth
            >
                Submit Complaint
            </Button>
        </Box>
    )}



<Snackbar
  open={snackbar.open}
  autoHideDuration={6000} // 6 seconds
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  anchorOrigin={{ 
    vertical: "top",     // Position at top
    horizontal: "center" // Center horizontally
  }}
  sx={{ 
    marginTop: "50px",   // Optional: Adjust vertical spacing
  }}
>
  <MuiAlert
    elevation={6}
    variant="filled"
    severity={snackbar.severity}
    onClose={() => setSnackbar({ ...snackbar, open: false })}
    sx={{ 
      width: "100%",     // Optional: Control width
    }}
  >
    {snackbar.message}
  </MuiAlert>
</Snackbar>
</Paper>

    );
};

export default ComplainForm;
